/** `<img>` with an optional WebP `<source>` in front of it - plain `<img>` when webpSrc is absent. */
export function PictureImg({
  webpSrc,
  webpSrcSet,
  alt,
  sizes,
  srcSet,
  ...imgProps
}: {
  webpSrc?: string
  webpSrcSet?: string
  alt: string
} & React.ImgHTMLAttributes<HTMLImageElement>) {
  const webpSet = webpSrcSet ?? webpSrc

  if (!webpSet) {
    return <img alt={alt} sizes={sizes} srcSet={srcSet} {...imgProps} />
  }

  return (
    <picture>
      <source type="image/webp" srcSet={webpSet} sizes={sizes} />
      <img alt={alt} sizes={sizes} srcSet={srcSet} {...imgProps} />
    </picture>
  )
}
